import { z } from "zod";

export const CREATE_CONTACT_CASE_VIEW_MODEL_SCHEMA = z.object({
  details: z.string().min(1, "Your message is required"),
  name: z.string().min(1, "Name is required"),
  emailOrPhone: z.string().min(1, "Email or phone is required"),
});

export type CreateContactCaseViewModel = z.infer<typeof CREATE_CONTACT_CASE_VIEW_MODEL_SCHEMA>;
